export const signupConfirmation = {
  extends: 'Page',
  metadata: { title: 'Confirm email / Symbols' },
  flow: 'y',
  align: 'center center',
  padding: 'D C',
  width: '100%',
  minHeight: '100dvh',
  maxWidth: 'none',

  state: { loading: true, success: false, error: null },

  onInit: async (el, s) => {
    await el.call('confirmEmail')
  },

  ConfirmCard: {
    flow: 'y',
    gap: 'C',
    padding: 'D',
    width: '100%',
    maxWidth: 'I',
    round: 'C',
    background: 'overlay',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'line',
    boxShadow: '0 24px 60px -24px var(--color-shadow)',

    Head: {
      flow: 'y',
      gap: 'A',
      Eyebrow: {
        tag: 'span',
        fontSize: 'Z2',
        fontWeight: '700',
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: 'blue',
        text: 'Email confirmation'
      },
      Title: {
        tag: 'h1',
        fontSize: 'D',
        fontWeight: '800',
        color: 'title',
        letterSpacing: '-0.02em',
        text: 'Verifying your email'
      }
    },

    Body: {
      flow: 'y',
      gap: 'B',
      align: 'center center',

      LoadingState: {
        if: (el, s) => s.loading,
        flow: 'y',
        align: 'center center',
        gap: 'B',
        Spinner: { size: 'D' },
        Text: { text: 'Confirming your email...', fontSize: 'B', color: 'caption' }
      },

      EmailConfirmationSuccess: {
        if: (el, s) => !s.loading && s.success
      },

      EmailConfirmationError: {
        if: (el, s) => !s.loading && !s.success
      }
    }
  }
}
